<template>
  <div class="mod-article-inner">
    <preview-job-content-header title="1日の仕事の流れ" />
    <p
      class="detail-title-lv3 pega-pre-wrap"
      data-test="caption"
      v-text="caption"
    />
    <div class="mod-detail-schedule">
      <p
        v-for="(timeSchedule, i) in timeSchedules"
        :key="i"
        :data-test="`time-schedule-${i}`"
      >
        {{ timeSchedule.hour | zeroPadding }}:{{ timeSchedule.minute | zeroPadding }}<span class="full-width-space" />{{ timeSchedule.note }}
      </p>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/base" as *;
</style>

<script>
import PreviewJobContentHeader from '@/components/atoms/PreviewJobContentHeader'

export default {
  components: {
    PreviewJobContentHeader
  },
  filters: {
    zeroPadding: (value) => {
      return value.toString().padStart(2, '0')
    }
  },
  props: {
    timeSchedules: {
      type: Array,
      required: true
    },
    caption: {
      type: String,
      required: true
    }
  }
}
</script>
